var _rect, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#9FBAFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#9FBAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10.0003C14.8954 10.0003 14 10.8958 14 12.0003C14 13.1049 14.8954 14.0003 16 14.0003C17.1046 14.0003 18 13.1049 18 12.0003C18 10.8958 17.1046 10.0003 16 10.0003ZM12.6667 12.0003C12.6667 10.1594 14.1591 8.66699 16 8.66699C17.841 8.66699 19.3333 10.1594 19.3333 12.0003C19.3333 13.8413 17.841 15.3337 16 15.3337C14.1591 15.3337 12.6667 13.8413 12.6667 12.0003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 22.6667C9.33333 18.9848 12.3181 16 16 16C19.6819 16 22.6667 18.9848 22.6667 22.6667C22.6667 23.0349 22.3682 23.3333 22 23.3333C21.6318 23.3333 21.3333 23.0349 21.3333 22.6667C21.3333 19.7212 18.9455 17.3333 16 17.3333C13.0545 17.3333 10.6667 19.7212 10.6667 22.6667C10.6667 23.0349 10.3682 23.3333 9.99999 23.3333C9.63181 23.3333 9.33333 23.0349 9.33333 22.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "clientapp/media/user.bccc2066.svg";
export { ForwardRef as ReactComponent };